import sharedFooterTemplate from 'views/chrome/shared-footer.html';
import { SharedHeaderFooterController } from './shared-header-footer.controller';

export class SharedFooterComponent implements ng.IComponentOptions {
  public controller: any;
  public templateUrl: string;
  public bindings: { [binding: string]: string };

  constructor() {
    this.controller = SharedHeaderFooterController;
    this.templateUrl = sharedFooterTemplate;
    this.bindings = {
      authenticated: '<',
    };
  }
}
